import IconButton from "@mui/material/IconButton";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
import healthExLogo from "../Media/HealthExLogo2023.png";
import { FlexColumn, FlexRowDiv, HorizontalDivider } from "./common.styles";
import { mobilePageHPadding } from "./HXMobilePage.styles";
export const HeaderViewParent = styled.div `
    padding: 32px ${mobilePageHPadding}px 8px ${mobilePageHPadding}px;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1;
    gap: 8px;
    background-color: ${colors.white_background};
`;
export const HeaderViewFocusedParent = styled(HeaderViewParent) `
    padding: 32px ${mobilePageHPadding}px 16px ${mobilePageHPadding}px;
`;
export const HeaderLine1 = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
`;
export const OrgLogoImage = styled.img `
    display: block;
    object-fit: contain;
    height: 20px;
`;
export const FallbackName = styled.div `
    display: none;
    font-size: ${fontSizes.SMALL};
`;
export const OrgLogoImageWithFallback = styled.div `
    &.fallback ${FallbackName} {
        display: block;
    }

    &.fallback ${OrgLogoImage} {
        display: none;
    }
`;
export const FocusedPageTitle = styled.div `
    margin-left: auto;
    margin-right: auto;
    font-weight: 600;
`;
export const BackIconButton = styled(IconButton) `
    height: 40px;
    width: 40px;
`;
export const BackIconButtonSpacer = styled.div `
    height: 24px;
    width: 24px;
`;
export const CompanyLogo = styled.img.attrs({ src: healthExLogo }) `
    height: 20px;
`;
export const Logos = styled(FlexRowDiv) `
    gap: 8px;
    align-items: center;
`;
export const HeaderViewHorizontalDivider = styled(HorizontalDivider) `
    margin-bottom: 12px;
`;
export const MobileHeaderContainer = styled(FlexColumn) `
    align-items: center;
    padding: 24px ${mobilePageHPadding}px ${({ paddingBottom }) => paddingBottom}px ${mobilePageHPadding}px;
`;
